export default __webpack_public_path__ + "static/media/sassi_2.e4e35ff6.png";